import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";

type DefaultResponse<T> = {
  success: boolean;
  message: string;
  data: T;
};

export interface ILead {
  id: string;
  // add any other fields you care about
  quoteId?: string;
}

export default function useLeadsByQuote(quoteId: string) {
  const { get } = useApiHelper();

  const shouldFetch = !!quoteId;

  const leads = useQuery(
    ["leadsByQuote", quoteId],
    () => get<DefaultResponse<ILead[]>>(`/lead/by/quote/${quoteId}`),
    { enabled: shouldFetch }
  );

  return { leads };
}